import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PricePipe } from '../../common/pipes/price.pipe';
import { PricingDetailsBreakdownComponent } from './pricing-details-breakdown.component';
import { PricingDetailsDialogComponent } from './pricing-details-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatOptionModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatExpansionModule,
    MatListModule,
    ReactiveFormsModule,
    PricePipe,
  ],
  declarations: [PricingDetailsDialogComponent, PricingDetailsBreakdownComponent],
  providers: [],
  exports: [PricingDetailsDialogComponent],
})
export class PricingDetailsModule {}
